import { render, staticRenderFns } from "./CustomerCategory.vue?vue&type=template&id=0d987d8c&scoped=true&"
import script from "./CustomerCategory.vue?vue&type=script&lang=js&"
export * from "./CustomerCategory.vue?vue&type=script&lang=js&"
import style0 from "./CustomerCategory.vue?vue&type=style&index=0&id=0d987d8c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d987d8c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCheckbox,VDataTable,VLayout})
